module.exports = __webpack_public_path__ + "static/media/improve-customer-engagement.bfcce012.png";